import { Shipment, ShipmentState } from "../../../../reducers/uploadedBoard";
import { useUpdateShipments } from "../../../../utils/hooks/commonly-stored/uploaded-board/updates/shipments";
import {
  ShipmentActionContainer,
  ShipmentDetail,
  LoadingPill,
  ShipmentsRowContainer,
} from "./ShipmentsStyles";
import { FakeLink, InputLabel, Pill } from "../../../../constants/Styles";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import Modal from "../../../common/Modal";
import AddOrEditShipment from "./AddOrEditShipment";
import { useState } from "react";
import { dateStringToHumanReadableDate } from "../../../../utils/valueFormatting";

export default function EditableShipmentRow({
  shipment,
  allowRemove,
}: {
  shipment: Shipment;
  allowRemove?: boolean;
}) {
  const [editingShipment, setEditingShipment] = useState<boolean>(false);
  const { removeShipment } = useUpdateShipments();

  return (
    <>
      <ShipmentsRowContainer>
        <ShipmentDetail>
          <InputLabel>Number of boards</InputLabel>
          <div>{shipment.num_boards.toLocaleString()}</div>
        </ShipmentDetail>
        <div>
          <InputLabel>Lead time days</InputLabel>
          <div>{shipment.lead_time_days.toLocaleString()}</div>
        </div>
        <div style={{ flex: 1 }}>
          <InputLabel>Ship date</InputLabel>

          {shipment.state == ShipmentState.PROCESSING ? (
            <LoadingPill>
              <Pill width={"100%"} />
            </LoadingPill>
          ) : (
            <div>{dateStringToHumanReadableDate(shipment.ship_date, true)}</div>
          )}
        </div>
        {allowRemove && (
          <ShipmentActionContainer>
            <FakeLink onClick={() => removeShipment(shipment.id)}>
              Remove
            </FakeLink>
          </ShipmentActionContainer>
        )}
        <ShipmentActionContainer>
          <FakeLink onClick={() => setEditingShipment(true)}>Edit</FakeLink>
        </ShipmentActionContainer>
        <Modal
          isOpen={editingShipment}
          onRequestClose={() => setEditingShipment(false)}
        >
          <ModalContentWithCloseButton
            closeModal={() => setEditingShipment(false)}
            title={"Edit shipment"}
          >
            <AddOrEditShipment
              shipmentId={shipment.id}
              onUpdate={() => setEditingShipment(false)}
            />
          </ModalContentWithCloseButton>
        </Modal>
      </ShipmentsRowContainer>
    </>
  );
}
